import MainConnection from "./MainConnection";

export default {
  requestFactsheetList: async function() {
    try {
      const requestURL = "/fact/list";
      const response = await MainConnection.request().get(requestURL);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestCreateNewFactsheet: async function(params) {
    try {
      const requestURL = "/fact/save/";
      const response = await MainConnection.request().post(requestURL, params);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestFactsheetById: async function(fact_id) {
    try {
      const requestURL = "/fact/" + fact_id;
      const response = await MainConnection.request().get(requestURL);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestDownloadFactsheetById: async function(fact_id) {
    try {
      const requestURL = "/fact/download";
      const response = await MainConnection.request().post(
        requestURL,
        {
          _id: fact_id
        },
        {
          responseType: "arraybuffer"
        }
      );
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestRemoveFactsheetById: async function(fact_id) {
    try {
      const requestURL = "/fact/" + fact_id;
      const response = await MainConnection.request().delete(requestURL);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  }
};
